import { environment } from "src/environments/environment";

interface Scripts {
  name: string;
  src: string;
}
export const ScriptStore: Scripts[] = [
  {
    name: 'categories',
    src: environment.categoryScript,
  },
];
